import Portal from 'components/portal';
import React from 'react';
interface ModalProps {
  children: React.ReactNode;
  isOnclickBackground?: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
const Modal = ({
  children,
  isOnclickBackground,
  isOpen,
  setIsOpen,
}: ModalProps) => {
  return (
    <>
      {isOpen && (
        <div>
          <Portal>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none mx-8 ">
              {children}
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black -mx-3" />
          </Portal>
        </div>
      )}
    </>
  );
};

Modal.defaultProps = {
  isOnclickBackground: true,
};
export default Modal;
